import React, { useState } from 'react';
import ModalBoxPopup from '../product/component/ModalBoxPopup';
import Zoomproduct from '../../Component/Zoomproduct';
import { Overlay } from 'react-bootstrap';

function GridListingData({
  Modal,
  show,
  handleClose,
  Button,
  handlePrev,
  Product,
  currentIndex,
  handleNext
}) {
  const [detailModalShow, setDetailModalShow] = useState(false);
  const [zoomModalShow, setZoomModalShow] = useState(false);
  // FIX: get product object first
  const currentProduct = Product?.[currentIndex] || null;
  const currentImage = currentProduct?.image_path || null;

  const handleImageClick = () => {
    setDetailModalShow(true);
  };

  const handleDetailModalClose = () => {
    setDetailModalShow(false);
  };

  const handleZoomClick = () => {
    setZoomModalShow(true);
  };

  const handleZoomClose = () => {
    setZoomModalShow(false);
  };

  return (
    <>
      {/* MAIN MODAL */}
      <Modal show={show} onHide={handleClose} fullscreen centered>
        <div className="modal-content" style={{ background: "rgb(249 249 249)" }}>
          <Modal.Body className="text-center p-0" style={{ overflowY: "hidden" }}>

            <Button
              variant="light"
              onClick={handleClose}
              className="position-absolute top-0 end-0 close-btns"
              style={{ zIndex: 1050 }}
            >
              <i className="bi bi-x-lg"></i>
            </Button>

            <div className="modal-image-container-BOX d-flex justify-content-center align-items-center">

              <Button
                className="bg-transparent"
                variant="secondary"
                onClick={handlePrev}
                disabled={!Product?.length || currentIndex <= 0}
              >
                <i className="bi bi-chevron-left"></i>
              </Button>

              <div style={{ position: 'relative' }}>

                {/* IMAGE */}
                {currentImage ? (
                  <>
                    <img
                      src={currentImage}
                      alt={currentProduct?.design || "product"}
                      style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                      onClick={() => {
                        if (window.innerWidth <= 768) {
                          window.location.href = '/mobileGrid';
                        } else {
                          handleImageClick();
                        }
                      }}
                    />

                    {/* ZOOM ICON */}
                    <span
                      className="zoomicon"
                      onClick={handleZoomClick}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="bi bi-zoom-in"></i>
                    </span>
                  </>
                ) : (
                  <p>No image available</p>
                )}

                {/* TITLE */}
                <h3
                  className="text-xl text-gray-500 mt-3"
                  style={{ fontSize: "16px" }}
                >
                  {currentProduct?.quality_name} <span style={{color:"#ff935c"}}> {currentProduct?.design}  {currentProduct?.shade}  </span>
                </h3>

              </div>

              <Button
                className="bg-transparent"
                variant="secondary"
                onClick={handleNext}
                disabled={!Product?.length || currentIndex >= Product.length - 1}
              >
                <i className="bi bi-chevron-right"></i>
              </Button>

            </div>
          </Modal.Body>
        </div>
      </Modal>

      {/* DETAIL MODAL */}
      <ModalBoxPopup
        Modal={Modal}
        detailModalShow={detailModalShow}
        handleDetailModalClose={handleDetailModalClose}
        Button={Button}
        currentImage={currentImage}
        product={currentProduct}
      />

      {/* ZOOM MODAL */}
      <Zoomproduct
        show={zoomModalShow}
        onHide={handleZoomClose}
        currentImage={currentImage}
      />
    </>
  );
}

export default GridListingData;